import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/campaigns/$campaignId')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/connect/campaigns/$campaignId/',
      params: { campaignId: params.campaignId },
    });
  },
});
